import { render, staticRenderFns } from "./FeeDisclaimer.vue?vue&type=template&id=3e21bd5c&scoped=true&"
import script from "./FeeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./FeeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./FeeDisclaimer.vue?vue&type=style&index=0&id=3e21bd5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e21bd5c",
  null
  
)

export default component.exports